import { EventData } from "../models/event";
import { isEventPastOrArchived } from "./eventDisplay";

export function isEventUnderAdminReview(
  event: Pick<EventData, "status">,
): boolean {
  return event.status === "requested";
}

/** Completed / archived: setup screens are view-only. */
export function isEventSetupReadOnly(
  event: Pick<EventData, "status"> | undefined,
): boolean {
  if (!event?.status) return false;
  return event.status === "completed" || event.status === "archived";
}

/** QR download / share only for active live events. */
export function canDownloadEventQr(
  event: Pick<EventData, "status" | "end_date" | "end_time"> | undefined,
): boolean {
  if (!event) return false;
  if (isEventPastOrArchived(event)) return false;
  return event.status === "published" || event.status === "scheduled";
}

export function showPastEventDetailsMenu(status?: string): boolean {
  return status === "completed" || status === "archived";
}

export function isEventSetupRoute(pathname: string): boolean {
  return /\/(edit-event|add-event-details|add-event-ticket|add-event-ticket-form|add-event-custom-form|review-and-publish)\//.test(
    pathname,
  );
}

export function canEditEventSetup(
  event: Pick<EventData, "status">,
): boolean {
  if (!event.status || event.status === "draft") return true;
  if (event.status === "rejected") return true;
  return false;
}

/** Schedule and venue are locked once the first ticket is booked. */
export function isScheduleAndVenueLocked(
  event: Pick<EventData, "has_registrations"> | undefined,
): boolean {
  return !!event?.has_registrations;
}

export function canEditScheduleAndVenue(
  event: Pick<EventData, "has_registrations" | "status"> | undefined,
): boolean {
  if (!event || isEventSetupReadOnly(event)) return false;
  if (event.status === "requested") return false;
  return !event.has_registrations;
}
